import { IAttendeeOrganizationDTO } from '../../api/attendees.dao';
import { MeetingStatus } from '../../api/meetings.dao';
import { SORT_DEC, SORT_INC } from '../../constants/common.constants';

interface IMeeting {
    meetingId: number;
    presenters: IAttendeeOrganizationDTO[];
    status: MeetingStatus;
}

export const sortById = (items, idKey = 'id') => {
    items.sort((a, b) => a[idKey] - b[idKey]);
};

export const sortByFirstPresenterOrgName = <T extends IMeeting>(items: T[]) => {
    items.sort((a, b) => {
        // Sort list by first presenter organization name (items without presenter organization at the bottom)
        const [presenterA] = a.presenters;
        const [presenterB] = b.presenters;

        const presenterAName = presenterA?.name.toLowerCase();
        const presenterBName = presenterB?.name.toLowerCase();

        if (presenterAName > presenterBName) {
            return SORT_INC;
        } else if (!presenterBName || presenterAName < presenterBName) {
            return SORT_DEC;
        }

        return 0;
    });
};

export const sortByCancelledStatus = <T extends IMeeting>(items: T[]) => {
    items.sort((a, b) => { // Sort list by status (cancelled at the bottom)
        if (a.status !== MeetingStatus.Cancelled && b.status === MeetingStatus.Cancelled) {
            return SORT_DEC;
        }

        return 0;
    });
};

export const getSortedMeetingsByPresenterName = <T extends IMeeting>(items: T[] = []): T[] => {
    const result = items.slice();
    sortById(result, 'meetingId');
    sortByFirstPresenterOrgName<T>(result);
    sortByCancelledStatus<T>(result);

    return result;
};
